import { render, staticRenderFns } from "./gtr-chairs-loader.vue?vue&type=template&id=35495dbe&scoped=true"
var script = {}
import style0 from "./gtr-chairs-loader.vue?vue&type=style&index=0&id=35495dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35495dbe",
  null
  
)

export default component.exports